<template>
	<el-dialog :visible.sync="visible"
		:title="$t('retailInstance.text.batchOpen')"
		:close-on-click-modal="false"
		:before-close="handleClose" class="bind-dialog  create-host">
        <batch-instance-table v-bind="$attrs" :multipleSelection="multipleSelection">
        </batch-instance-table>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind"
				type="primary">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import BatchInstanceTable from '@/components/common/BatchInstanceTable';
export default {
	name: 'BatchOpen',
    components: {
        BatchInstanceTable
    },
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		multipleSelection: {
			type: Array,
			default: []
		},
		region: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
		};
	},
	methods: {

		handleClose() {
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
		sureBind() {
			let instanceIds = this.multipleSelection.map(item => item.instanceId)
			const params = {
				region: this.region,
				instanceIds
			};

			Ajax.put('/api/cps/startInstances', params,{
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
				this.$emit('refresh');
			});
		},
	}
};
</script>

<style lang="scss">
	.bind-dialog {
		.chooseInfo {
			margin-bottom: 5px;
			font-size: 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BatchOpen.vue